import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const downloadReceiptPdf = async (elementId: string, filename: string): Promise<void> => {
  const element = document.getElementById(elementId)
  if (!element) return

  element.setAttribute('data-pdf-capture', 'true')
  element.offsetHeight // force reflow so .hide-in-pdf rules apply before capture

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true
    })
    const imgData = canvas.toDataURL('image/png')

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
    const imgWidth = 190
    const pageHeight = 277
    const imgHeight = (canvas.height * imgWidth) / canvas.width

    let heightLeft = imgHeight
    let position = 10

    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight)
    heightLeft -= pageHeight

    while (heightLeft > 0) {
      position = heightLeft - imgHeight + 10
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight)
      heightLeft -= pageHeight
    }

    pdf.save(filename)
  } finally {
    element.removeAttribute('data-pdf-capture')
  }
}
